import React, { useState,useContext } from "react";
import AppContext from '../Context/AppContext';
import axios from "axios";

const VideoItem = ({ video, handleSelect, isSelected }) => {
    const [expanded, setExpanded] = useState(false);

    const truncate = (text, maxLength = 30) => {
        if (!text) return "";
        if (text.length <= maxLength || expanded) return text;
        return text.slice(0, maxLength) + "...";
    };

    return (
        <div
            style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "10px",
                marginBottom: "10px",
            }}
            className={`${isSelected ? "bcs" : ""}`}
            onClick={() => handleSelect(video)}
        >
            <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                {new Date(video.last_watch).toLocaleString()}
            </div>
            <div>
                {truncate(video.video_name)}
                {video.video_name.length > 30 && (
                    <button
                        style={{
                            marginLeft: "8px",
                            color: "blue",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                        }}
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Read less" : "Read more"}
                    </button>
                )}
            </div>
        </div>
    );
};

const VideoStreamItem = ({ data, reset, type }) => {
     const { mapUrl } = useContext(AppContext)
    const [selected, setSelected] = useState([]);
    const [load,setLoad]=useState(false)
    const [progress, setProgress] = useState(null) // { mode, done, total, failed }

    /** "disk" : supprime sur le serveur de stream + en base. "db" : en base seulement (deja efface du disque) */
    const deleteUrl = (mode) => {
        if (mode !== "db") return mapUrl.delete_video;
        // meme domaine + token que delete_video, seule la route change
        if (mapUrl.delete_video_db) return mapUrl.delete_video_db;
        if (mapUrl.delete_video?.includes("/delete-video-stream/")) return mapUrl.delete_video.replace("/delete-video-stream/", "/delete-video-db/");
        return null;
    }

    const handleDelete= async (mode)=>{
        if(!load && selected?.length > 0){
            const baseUrl = deleteUrl(mode);
            if (!baseUrl) return alert("URL de suppression en base introuvable (config delete_video_db)");

            setLoad(true);
            const total = selected.length;
            let failed = 0;
            setProgress({ mode, done: 0, total, failed });
            for (let i = 0; i < total; i++) {
                const {id} = selected[i];
                const _url = baseUrl.replace("${id}",id).replace("${type}", type);
                try {
                    const response = await axios.get(_url);
                    if (!response?.data?.success) failed++;
                } catch (err) {
                    // une erreur ne bloque plus la suite
                    failed++;
                }
                setProgress({ mode, done: i + 1, total, failed });
            }
            setSelected([]);
            reset();
            setLoad(false)
        }
    }
    const percent = progress?.total ? Math.round((progress.done / progress.total) * 100) : 0;

    return (
        <div>
            <div className="df gap1 aic mb2">
                <button
                    onClick={() =>
                        setSelected((prev) =>
                            prev.length === data.length ? [] : data
                        )
                    }
                    className="bcw cb px2 py1"
                >
                    Tout sélectionner
                </button>
                {selected?.length > 0 && (
                    <>
                        <button disabled={load} onClick={()=>handleDelete("disk")} className="bce fr cw px2 py1 ">{load ? "Chargement..." : "Supprimer"}</button>
                        <button disabled={load} onClick={()=>handleDelete("db")} className="bcw cb px2 py1" title="Déjà effacées du disque : retire seulement la ligne en base">{load ? "Chargement..." : "Supprimer en base"}</button>
                    </>
                )}
            </div>
            {progress && (
                <div className='mb-progress mb2'>
                    <div className='mb-bar'><div className='mb-bar-fill' style={{ width: `${percent}%` }}></div></div>
                    <p className='cw fr fs12 mt1'>
                        {progress.mode === "db" ? "Suppression en base" : "Suppression"} {progress.done}/{progress.total} ({percent}%)
                        {progress.failed > 0 ? ` · ${progress.failed} échec(s)` : ""}
                        {!load ? " · terminé" : ""}
                    </p>
                </div>
            )}
            {data?.length > 0 && data.map((item) => (
                <VideoItem handleSelect={(v) => {
                    setSelected((prev) => {
                        const exists = prev.some((x) => x.id === v.id);
                        if (exists) {
                            // retirer l'item
                            return prev.filter((x) => x.id !== v.id);
                        } else {
                            // ajouter l'item
                            return [...prev, v];
                        }
                    });
                }}
                    isSelected={selected.find(e => e.id == item.id)}
                    key={item.id}
                    video={item} />
            ))}
        </div>
    );
};

export default VideoStreamItem;
